// 获取本地存储数据
export function getMessage(str) {
  const o = localStorage[str];
  console.log("===="+o);
  if(str=="token"){
    return o;
  }
  if(o){
    return JSON.parse(o);
  }
}

// 设置本地存储数据
export function setMessage(str, obj) {
  localStorage[str] = JSON.stringify(obj);
}


// 清除所有本地存储
export function clearMessage() {
  localStorage.clear();
}